
import { Component, computed, input } from '@angular/core';
import { BadgeComponent } from 'nebula-ui-kit';
import type { PreservationFileStatus } from '../../../../domain/src/lib/preservation/preservation.model';

@Component({
  selector: 'app-preservation-status-badge',
  standalone: true,
  imports: [BadgeComponent],
  template: `
    <lib-badge [text]="label()" [variant]="variant()" size="small" />
  `,
})
export class PreservationStatusBadgeComponent {
  readonly status = input<PreservationFileStatus>('unverified');

  readonly label = computed(() => {
    const value = this.status();
    if (value === 'optimal') return 'Optimo';
    if (value === 'attention') return 'Atencion';
    if (value === 'critical') return 'Critico';
    return 'Sin verificar';
  });

  readonly variant = computed<'success' | 'warning' | 'error' | 'neutral'>(() => {
    const value = this.status();
    if (value === 'optimal') return 'success';
    if (value === 'attention') return 'warning';
    if (value === 'critical') return 'error';
    return 'neutral';
  });
}
